import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'SbToggleSwitch',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isToggleWithText: {
            type: Boolean,
            required: false,
            default: false,
        },
        offText: {
            type: String,
            required: false,
            default: 'no',
        },
        onText: {
            type: String,
            required: false,
            default: 'yes',
        },
        style: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        onChange: function (event) {
            var checked = event.target.checked;
            this.$emit('input', checked);
        },
    },
});

export default script;
